import createReducer from 'utils/redux/createReducer'

const initialState = {
  projectTypeID : "",
  propertyID : "",
  managerID : ""
}

export default createReducer(initialState, {
  TASK_TYPE_CHANGED: (currentState, action) => ({...currentState, taskType : action.data.target.parentElement.parentElement.parentElement.getAttribute('data-value')})
  , TASK_CHANGED: (currentState, action) => ({...currentState, task : action.data.target.parentElement.parentElement.parentElement.getAttribute('data-value')})
  , PROJECT_TYPE_CHANGED: (currentState, action) => ({...currentState, projectTypeID: action.data})
  , PROPERTY_CHANGED: (currentState, action) => ({...currentState, propertyID: action.data})
  , MANAGER_CHANGED: (currentState, action) => ({...currentState, managerID: action.data})
  , NOTE_CHANGED: (currentState, action) => ({...currentState, note: action.data.target.value})
})



// WEBPACK FOOTER //
// ./src/reducers/projectReducers.js